module.exports = {
    text: "<p>W celu monitorowania ruchu użytkowników na stronie stosujemy pliki cookies. Korzystanie z naszej witryny oznacza, że będą one zamieszczane w Państwa urządzeniu. W każdym momencie można dokonać zmiany ustawień Państwa przeglądarki. Zobacz <strong><a href='/privacy-policy' target='_blank'>Politykę prywatności</a></strong>.</p>",
    link: "Polityka prywatności"
}
